<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-icon>mdi-view-list</v-icon>
              <v-toolbar-title>GL Transactions </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-flex xs12>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex md4 xs12>
                          <v-text-field
                            v-model="glListingForm.documentNo"
                            :label="glListingLabel.documentNo"
                            readonly
                            :error-messages="errors.collect('glListingForm.documentNo')"
                            data-vv-name="glListingForm.documentNo"
                            :data-vv-as="glListingLabel.documentNo"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md2 xs12>
                          <v-text-field
                            v-model="glListingForm.amountCurr"
                            :label="glListingLabel.amountCurr"
                            readonly
                            :error-messages="errors.collect('glListingForm.amountCurr')"
                            data-vv-name="glListingForm.amountCurr"
                            :data-vv-as="glListingLabel.amountCurr"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md6 xs12>
                          <v-text-field
                            v-model="glListingForm.amount"
                            :label="glListingLabel.amount"
                            readonly
                            :error-messages="errors.collect('glListingForm.amount')"
                            data-vv-name="glListingForm.amount"
                            :data-vv-as="glListingLabel.amount"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md4 xs12> </v-flex>
                        <v-flex md2 xs12> </v-flex>
                        <v-flex md6 xs12>
                          <v-text-field
                            v-model="glListingForm.gstAmount"
                            :label="glListingLabel.gstAmount"
                            readonly
                            :error-messages="errors.collect('glListingForm.gstAmount')"
                            data-vv-name="glListingForm.gstAmount"
                            :data-vv-as="glListingLabel.gstAmount"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md4 xs12> </v-flex>
                        <v-flex md2 xs12> </v-flex>
                        <v-flex md6 xs12>
                          <v-text-field
                            v-model="glListingForm.netAmount"
                            :label="glListingLabel.netAmount"
                            readonly
                            :error-messages="errors.collect('glListingForm.netAmount')"
                            data-vv-name="glListingForm.netAmount"
                            :data-vv-as="glListingLabel.netAmount"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex md6 xs12>
                <v-text-field
                  v-model="glListingForm.remainAmountToPost"
                  :label="glListingLabel.remainAmountToPost"
                  readonly
                  :error-messages="errors.collect('glListingForm.remainAmountToPost')"
                  data-vv-name="glListingForm.remainAmountToPost"
                  :data-vv-as="glListingLabel.remainAmountToPost"
                ></v-text-field>
              </v-flex>
              <v-flex md6 xs12> </v-flex>
              <v-flex md6 xs12>
                <v-text-field
                  v-model="glListingForm.gstRemainAmount"
                  :label="glListingLabel.gstRemainAmount"
                  readonly
                  :error-messages="errors.collect('glListingForm.gstRemainAmount')"
                  data-vv-name="glListingForm.gstRemainAmount"
                  :data-vv-as="glListingLabel.gstRemainAmount"
                ></v-text-field>
              </v-flex>
              <v-flex md6 xs12> </v-flex>
              <v-flex xs12>
                <v-data-table v-bind:headers="glColumns" v-bind:items="itemsGL" item-key="key" :loading="loading" :no-data-text="noDataText">
                  <template v-slot:item="row"
                    ><tr>
                      <td v-for="column in selectedGLColumns" :key="column">{{ row.item[column] }}</td>
                      <td class="table-action-header">
                        <table-action :rowData="row" review @review="doEdit(row.item)" remove @remove="doRemove(row.item)"></table-action>
                      </td></tr
                  ></template>
                </v-data-table>
              </v-flex>
              <v-flex md6 xs12>
                <v-text-field
                  v-model="glListingForm.totalLocalAmount"
                  readonly
                  :label="glListingLabel.totalLocalAmount"
                  :error-messages="errors.collect('glListingForm.totalLocalAmount')"
                  data-vv-name="glListingForm.totalLocalAmount"
                  :data-vv-as="glListingLabel.totalLocalAmount"
                ></v-text-field>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-expansion-panels v-model="glPanel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-plus</v-icon><span class="headerTitle">GL Transaction Details</span></div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex md2 xs6>
                          <v-text-field
                            v-model="glPanelForm.glInterface"
                            :label="glPanelLabel.glInterface"
                            :disabled="true"
                            :error-messages="errors.collect('glPanelForm.glInterface')"
                            data-vv-name="glPanelForm.glInterface"
                            :data-vv-as="glPanelLabel.glInterface"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md2 xs6>
                          <v-text-field
                            v-model="glPanelForm.itemNo"
                            :label="glPanelLabel.itemNo"
                            :disabled="true"
                            :error-messages="errors.collect('glPanelForm.itemNo')"
                            data-vv-name="glPanelForm.itemNo"
                            :data-vv-as="glPanelLabel.itemNo"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-text-field
                            v-model="glPanelForm.mixGlAccountNo"
                            :label="glPanelLabel.mixGlAccountNo"
                            :error-messages="errors.collect('glPanelForm.mixGlAccountNo')"
                            data-vv-name="glPanelForm.mixGlAccountNo"
                            :data-vv-as="glPanelLabel.mixGlAccountNo"
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="showGlAcctNoHelpList = true" v-text="'mdi-magnify'"></v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-text-field
                            v-model="glPanelForm.description"
                            :label="glPanelLabel.description"
                            :disabled="true"
                            :error-messages="errors.collect('glPanelForm.description')"
                            data-vv-name="glPanelForm.description"
                            :data-vv-as="glPanelLabel.description"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md2 xs12>
                          <v-text-field
                            v-model="glPanelForm.curr"
                            :label="glPanelLabel.curr"
                            :disabled="true"
                            :error-messages="errors.collect('glPanelForm.curr')"
                            data-vv-name="glPanelForm.curr"
                            :data-vv-as="glPanelLabel.curr"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md5 xs12>
                          <v-text-field
                            v-model="glPanelForm.amount"
                            :label="glPanelLabel.amount"
                            :disabled="isDisabled"
                            :error-messages="errors.collect('glPanelForm.amount')"
                            data-vv-name="glPanelForm.amount"
                            :data-vv-as="glPanelLabel.amount"
                            v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                            v-validate="'mask_decimal:2'"
                            @blur="calculateAmount()"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md5 xs12>
                          <v-text-field
                            v-model="glPanelForm.localAmount"
                            :label="glPanelLabel.localAmount"
                            :disabled="true"
                            :error-messages="errors.collect('glPanelForm.localAmount')"
                            data-vv-name="glPanelForm.localAmount"
                            :data-vv-as="glPanelLabel.localAmount"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md2 xs12>
                          <v-autocomplete
                            :items="gstStatuses"
                            v-model="glPanelForm.gstStatus"
                            :disabled="isDisabled"
                            :label="glPanelLabel.gstStatus"
                            item-text="label"
                            item-value="value"
                            data-vv-name="glPanelForm.gstStatus"
                            :data-vv-as="glPanelLabel.gstStatus"
                            :error-messages="errors.collect('glPanelForm.gstStatus')"
                            @change="changeGstRate($event)"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex md5 xs12>
                          <v-text-field
                            v-model="glPanelForm.gstRate"
                            :label="glPanelLabel.gstRate"
                            :disabled="true"
                            :error-messages="errors.collect('glPanelForm.gstRate')"
                            data-vv-name="glPanelForm.gstRate"
                            :data-vv-as="glPanelLabel.gstRate"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md5 xs12>
                          <v-text-field
                            v-model="glPanelForm.gstAmount"
                            :label="glPanelLabel.gstAmount"
                            :disabled="true"
                            :error-messages="errors.collect('glPanelForm.gstAmount')"
                            data-vv-name="glPanelForm.gstAmount"
                            :data-vv-as="glPanelLabel.gstAmount"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-expansion-panels v-model="glAnCodePanel" multiple v-if="this.miscacctparams.glSys === 2">
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <div><v-icon>mdi-plus</v-icon><span class="headerTitle">GL Analysis Code (GL AC)</span></div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="grey lighten-5">
                        <v-card>
                          <v-card-text>
                            <v-container fluid grid-list-lg>
                              <v-layout row wrap>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="glPanelForm.glAnCode1"
                                    :label="glPanelLabel.glAnCode1"
                                    :error-messages="errors.collect('glPanelForm.glAnCode1')"
                                    data-vv-name="glPanelForm.glAnCode1"
                                    :data-vv-as="glPanelLabel.glAnCode1"
                                  >
                                    <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                      <v-icon color="info" @click="GLAnCodeHelpList('glAnCode1')" v-text="'mdi-magnify'"></v-icon>
                                    </v-slide-x-reverse-transition>
                                  </v-text-field>
                                </v-flex>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="glPanelForm.glAnCode2"
                                    :label="glPanelLabel.glAnCode2"
                                    :error-messages="errors.collect('glPanelForm.glAnCode2')"
                                    data-vv-name="glPanelForm.glAnCode2"
                                    :data-vv-as="glPanelLabel.glAnCode2"
                                  >
                                    <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                      <v-icon color="info" @click="GLAnCodeHelpList('glAnCode2')" v-text="'mdi-magnify'"></v-icon>
                                    </v-slide-x-reverse-transition>
                                  </v-text-field>
                                </v-flex>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="glPanelForm.glAnCode3"
                                    :label="glPanelLabel.glAnCode3"
                                    :error-messages="errors.collect('glPanelForm.glAnCode3')"
                                    data-vv-name="glPanelForm.glAnCode3"
                                    :data-vv-as="glPanelLabel.glAnCode3"
                                  >
                                    <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                      <v-icon color="info" @click="GLAnCodeHelpList('glAnCode3')" v-text="'mdi-magnify'"></v-icon>
                                    </v-slide-x-reverse-transition>
                                  </v-text-field>
                                </v-flex>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="glPanelForm.glAnCode4"
                                    :label="glPanelLabel.glAnCode4"
                                    :error-messages="errors.collect('glPanelForm.glAnCode4')"
                                    data-vv-name="glPanelForm.glAnCode4"
                                    :data-vv-as="glPanelLabel.glAnCode4"
                                  >
                                    <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                      <v-icon color="info" @click="GLAnCodeHelpList('glAnCode4')" v-text="'mdi-magnify'"></v-icon>
                                    </v-slide-x-reverse-transition>
                                  </v-text-field>
                                </v-flex>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="glPanelForm.glAnCode5"
                                    :label="glPanelLabel.glAnCode5"
                                    :error-messages="errors.collect('glPanelForm.glAnCode5')"
                                    data-vv-name="glPanelForm.glAnCode5"
                                    :data-vv-as="glPanelLabel.glAnCode5"
                                  >
                                    <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                      <v-icon color="info" @click="GLAnCodeHelpList('glAnCode5')" v-text="'mdi-magnify'"></v-icon>
                                    </v-slide-x-reverse-transition>
                                  </v-text-field>
                                </v-flex>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="glPanelForm.glAnCode6"
                                    :label="glPanelLabel.glAnCode6"
                                    :error-messages="errors.collect('glPanelForm.glAnCode6')"
                                    data-vv-name="glPanelForm.glAnCode6"
                                    :data-vv-as="glPanelLabel.glAnCode6"
                                  >
                                    <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                      <v-icon color="info" @click="GLAnCodeHelpList('glAnCode6')" v-text="'mdi-magnify'"></v-icon>
                                    </v-slide-x-reverse-transition>
                                  </v-text-field>
                                </v-flex>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="glPanelForm.glAnCode7"
                                    :label="glPanelLabel.glAnCode7"
                                    :error-messages="errors.collect('glPanelForm.glAnCode7')"
                                    data-vv-name="glPanelForm.glAnCode7"
                                    :data-vv-as="glPanelLabel.glAnCode7"
                                  >
                                    <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                      <v-icon color="info" @click="GLAnCodeHelpList('glAnCode7')" v-text="'mdi-magnify'"></v-icon>
                                    </v-slide-x-reverse-transition>
                                  </v-text-field>
                                </v-flex>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="glPanelForm.glAnCode8"
                                    :label="glPanelLabel.glAnCode8"
                                    :error-messages="errors.collect('glPanelForm.glAnCode8')"
                                    data-vv-name="glPanelForm.glAnCode8"
                                    :data-vv-as="glPanelLabel.glAnCode8"
                                  >
                                    <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                      <v-icon color="info" @click="GLAnCodeHelpList('glAnCode8')" v-text="'mdi-magnify'"></v-icon>
                                    </v-slide-x-reverse-transition>
                                  </v-text-field>
                                </v-flex>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="glPanelForm.glAnCode9"
                                    :label="glPanelLabel.glAnCode9"
                                    :error-messages="errors.collect('glPanelForm.glAnCode9')"
                                    data-vv-name="glPanelForm.glAnCode9"
                                    :data-vv-as="glPanelLabel.glAnCode9"
                                  >
                                    <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                      <v-icon color="info" @click="GLAnCodeHelpList('glAnCode9')" v-text="'mdi-magnify'"></v-icon>
                                    </v-slide-x-reverse-transition>
                                  </v-text-field>
                                </v-flex>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="glPanelForm.glAnCode10"
                                    :label="glPanelLabel.glAnCode10"
                                    :error-messages="errors.collect('glPanelForm.glAnCode10')"
                                    data-vv-name="glPanelForm.glAnCode10"
                                    :data-vv-as="glPanelLabel.glAnCode10"
                                  >
                                    <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                      <v-icon color="info" @click="GLAnCodeHelpList('glAnCode10')" v-text="'mdi-magnify'"></v-icon>
                                    </v-slide-x-reverse-transition>
                                  </v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="doPanelCancel">Cancel</v-btn>
                      <v-btn color="primary" text @click.native="doPanelSave">Save</v-btn>
                    </v-card-actions>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12>
          <v-btn class="mr-2" color="error" dark @click.prevent="doCancel"> {{ glListingLabel.cancel }}<v-icon dark right>mdi-cancel</v-icon> </v-btn>
          <v-btn class="mr-2" color="info" dark @click.prevent="doEpandGLDesc">
            {{ glListingLabel.addGLAccount }}<v-icon dark right>mdi-clipboard-plus</v-icon>
          </v-btn>
          <v-btn class="mr-2" color="primary" dark @click.prevent="doProceed('SAVE_GL_TRANS')">
            {{ glListingLabel.proceed }}<v-icon dark right>mdi-arrow-right-bold-box</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- GL Account No HelpList -->
    <v-dialog v-model="showGlAcctNoHelpList" width="1280px">
      <gl-acct-no-help-list3
        @close="showGlAcctNoHelpList = false"
        :objData="helpListParams"
        @assign-gl-acct-info="assignGlAcctInfo"
      ></gl-acct-no-help-list3>
    </v-dialog>
    <!-- GL AnCode HelpList -->
    <v-dialog v-model="showGLAnCodeHelpList" width="1280px">
      <gl-an-code-help-list @close="showGLAnCodeHelpList = false" @assign-gl-an-code="assignGlAnCodeInfo"></gl-an-code-help-list>
    </v-dialog>
    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-card-title primary-title>
          <div>
            <div class="headline">System Information</div>
            <span class="grey--text">An error occurred when creating GL Posting.</span>
          </div>
        </v-card-title>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <v-subheader>Error Details:</v-subheader>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="promptCannotRemoveAccount" width="50%" persistent>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>
              Warning
              <v-spacer></v-spacer>
              <v-btn text icon @click="closeDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-container fluid grid-list-sm>
                <v-layout row wrap>
                  <v-flex xs12>
                    {{ promptWarnMsg }}
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-dialog>
    <v-dialog v-model="processingFlag" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import { crGLTransactionAjaxMixin } from '@/mixins/accounting/creditNote/crGLTransactionAjaxMixin'
import { creditNoteViewMixin } from '@/mixins/accounting/creditNote/creditNoteViewMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { accountsFilters } from '@/mixins/accounting/accountsFilters'
import GlAcctNoHelpList3 from '@/components/core/common/dialog/GlAcctNoHelpList3'
import GlAnCodeHelpList from '@/components/core/common/dialog/GlAnCodeHelpList'
import { formatPrice } from '@/utils/index'
import { removeFormatNumber } from '@/utils/number'
import { formatDisplayDateTime2 } from '@/utils/date'

export default {
  data() {
    return {
      gstStatuses: [],
      trandaterange: {},
      currencies: {},
      showErrorDialog: false,
      showPromptLeave: true,
      processingFlag: false,
      gstrate: '0.00',
      glListingLabel: {
        documentNo: 'Document No',
        amountCurr: 'Amount Currency',
        amount: 'Amount',
        gstAmount: 'GST Amount',
        netAmount: 'Net Amount',
        remainAmountToPost: 'Remaining Amount to post',
        gstRemainAmount: 'GST for remaining amount',
        totalLocalAmount: 'Total Local Amount',
        addGLAccount: 'Add GL Account',
        proceed: 'Proceed',
        cancel: 'Cancel'
      },
      glPanelLabel: {
        glInterface: 'GL Interface',
        itemNo: 'Item No.',
        mixGlAccountNo: 'GL Account No',
        description: 'Description',
        curr: 'Currency',
        amount: 'Amount',
        localAmount: 'Local Amount',
        gstStatus: 'GST Status',
        gstRate: 'GST Rate',
        gstAmount: 'GST Amount',
        glAnCode1: 'GL Ac 1',
        glAnCode2: 'GL Ac 2',
        glAnCode3: 'GL Ac 3',
        glAnCode4: 'GL Ac 4',
        glAnCode5: 'GL Ac 5',
        glAnCode6: 'GL Ac 6',
        glAnCode7: 'GL Ac 7',
        glAnCode8: 'GL Ac 8',
        glAnCode9: 'GL Ac 9',
        glAnCode10: 'GL Ac 10',
        save: 'Save',
        cancel: 'Cancel'
      },
      glListingForm: {
        documentNo: '',
        amountCurr: '',
        amount: '0.00',
        gstAmount: '0.00',
        netAmount: '0.00',
        netLocalAmount: '0.00',
        remainAmountToPost: '0.00',
        gstRemainAmount: '0.00',
        totalLocalAmount: '0.00',
        bankTotalLocalCurr: '', // Base Currency
        bankTotalLocalCurrRate: '0.00' // Base Currency Rate
      },
      glPanelForm: {
        glInterface: '',
        itemNo: '',
        glAccountNo: '',
        description: '',
        curr: '',
        amount: '',
        localAmount: '',
        gstStatus: '',
        gstRate: '',
        gstAmount: '',
        branch: '',
        accountNoSuffix: '',
        fund: '',
        mixGlAccountNo: '',
        glAnCode1: '',
        glAnCode2: '',
        glAnCode3: '',
        glAnCode4: '',
        glAnCode5: '',
        glAnCode6: '',
        glAnCode7: '',
        glAnCode8: '',
        glAnCode9: '',
        glAnCode10: ''
      },
      glPanel: [],
      glAnCodePanel: [],
      itemsGL: [],
      itemsDeleteGL: [],
      isDisabled: true,
      selectedGLColumns: [
        'glInterface',
        'itemNo',
        'mixGlAccountNo',
        'description',
        'curr',
        'amount',
        'localAmount',
        'gstStatus',
        'gstRate',
        'gstAmount'
      ],
      GLColummn: [
        { text: 'GL Interface', value: 'glInterface' },
        { text: 'Item No.', value: 'itemNo' },
        { text: 'GL Account No.', value: 'mixGlAccountNo' },
        { text: 'Description', value: 'description' },
        { text: 'Curr', value: 'curr' },
        { text: 'Amount', value: 'amount' },
        { text: 'Local Amount', value: 'localAmount' },
        { text: 'GST Status', value: 'gstStatus' },
        { text: 'GST Rate', value: 'gstRate' },
        { text: 'GST Amount', value: 'gstAmount' },
        { text: '', value: 'glAnCode1' },
        { text: '', value: 'glAnCode2' },
        { text: '', value: 'glAnCode3' },
        { text: '', value: 'glAnCode4' },
        { text: '', value: 'glAnCode5' },
        { text: '', value: 'glAnCode6' },
        { text: '', value: 'glAnCode7' },
        { text: '', value: 'glAnCode8' },
        { text: '', value: 'glAnCode9' },
        { text: '', value: 'glAnCode10' }
      ],
      showGLAnCodeHelpList: false,
      miscacctparams: {},
      promptCannotRemoveAccount: false,
      promptWarnMsg: 'This record cannot be delete',
      glItemNo: 6,
      tempGLList: [],
      helpListParams: {
        acctNo: '',
        transactions: 'creditNote'
      }
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      await Promise.all([this.$store.dispatch('reportsInit')])
      await Promise.all([this.$store.dispatch('acctReportsInit')])
      this.glListingForm.documentNo = this.creditNoteData.type + ' ' + this.creditNoteData.documentNo
      this.glListingForm.amountCurr = this.creditNoteData.currency
      this.glListingForm.amount = this.creditNoteData.amount
      this.glListingForm.netLocalAmount = this.creditNoteData.netLocAmount
      this.glListingForm.gstAmount = this.creditNoteData.gstAmount
      this.glListingForm.netAmount = this.creditNoteData.netAmount
      this.getCommonDataList('gstStatuses')
      this.getCommonDataList('currencies')
      this.getCommonData('trandaterange', '005')
      this.getCommonData('miscacctparams')
      this.getAcctCreditNoteMenuLink()
      this.creditNoteGLTransList()
      // this.getBaseCurr(this.glListingForm)
      this.helpListParams.acctNo = this.nonTradeData.accountNo
      this.helpListParams.fund = this.nonTradeData.fund
    },
    doCancel() {
      this.$router.push({ name: 'createCreditNote' }).catch(() => {})
    },
    doEpandGLDesc() {
      this.glPanel = [0]
    },
    doProceed(actionName) {
      const errMsgTotLocAmt = {
        messages: [{ message: 'Total local amount must be zero', type: 'ERROR' }]
      }
      const errMsgGstAmt = {
        messages: [{ message: 'GST for remaining amount must be zero', type: 'ERROR' }]
      }
      if (this.glListingForm.totalLocalAmount !== '0.00') {
        this.message(errMsgTotLocAmt)
        this.fieldMessage(errMsgTotLocAmt)
      } else if (this.glListingForm.gstRemainAmount !== '0.00') {
        this.message(errMsgGstAmt)
        this.fieldMessage(errMsgGstAmt)
      } else {
        this.processingFlag = true
        this.doSaveGLTrans(actionName)
      }
    },
    doPanelCancel() {
      this.glPanel = []
      var thisPage = this
      Object.keys(this.glPanelForm).forEach(function (key, index) {
        thisPage.glPanelForm[key] = ''
      })
    },
    doPanelSave() {
      var isExist = 'false'

      if (this.itemsDeleteGL.length > 0) {
        for (var a = 0; a < this.itemsDeleteGL.length; a++) {
          const existData = {
            glInterface: this.itemsDeleteGL[a].glInterface,
            itemNo: this.itemsDeleteGL[a].itemNo,
            glAccountNo: this.itemsDeleteGL[a].glAccountNo,
            branch: this.itemsDeleteGL[a].branch,
            accountNoSuffix: this.itemsDeleteGL[a].accountNoSuffix,
            fund: this.itemsDeleteGL[a].fund
          }
          this.doRemove(existData)
        }
        this.itemsDeleteGL = []
      }

      for (var i = 0; i < this.itemsGL.length; i++) {
        if (
          this.itemsGL[i].glInterface === this.glPanelForm.glInterface &&
          this.itemsGL[i].glAccountNo === this.glPanelForm.glAccountNo &&
          this.itemsGL[i].mixGlAccountNo === this.glPanelForm.mixGlAccountNo &&
          this.itemsGL[i].itemNo === this.glPanelForm.itemNo
        ) {
          this.itemsGL[i].gstStatus = this.glPanelForm.gstStatus
          this.itemsGL[i].gstRate = this.glPanelForm.gstRate
          this.itemsGL[i].gstAmount = formatPrice(Number(removeFormatNumber(this.glPanelForm.gstAmount)))
          this.itemsGL[i].amount = formatPrice(Number(removeFormatNumber(this.glPanelForm.amount)))
          this.itemsGL[i].localAmount = formatPrice(Number(removeFormatNumber(this.glPanelForm.localAmount)))
          this.itemsGL[i].glAnCode1 = this.glPanelForm.glAnCode1
          this.itemsGL[i].glAnCode2 = this.glPanelForm.glAnCode2
          this.itemsGL[i].glAnCode3 = this.glPanelForm.glAnCode3
          this.itemsGL[i].glAnCode4 = this.glPanelForm.glAnCode4
          this.itemsGL[i].glAnCode5 = this.glPanelForm.glAnCode5
          this.itemsGL[i].glAnCode6 = this.glPanelForm.glAnCode6
          this.itemsGL[i].glAnCode7 = this.glPanelForm.glAnCode7
          this.itemsGL[i].glAnCode8 = this.glPanelForm.glAnCode8
          this.itemsGL[i].glAnCode9 = this.glPanelForm.glAnCode9
          this.itemsGL[i].glAnCode10 = this.glPanelForm.glAnCode10
          isExist = 'true'
        }
      }

      if (isExist === 'false') {
        const glDetailList = {
          glInterface: this.glPanelForm.glInterface,
          itemNo: this.glItemNo,
          glAccountNo: this.glPanelForm.glAccountNo,
          description: this.glPanelForm.description,
          curr: this.glPanelForm.curr,
          amount: formatPrice(Number(removeFormatNumber(this.glPanelForm.amount))),
          localAmount: formatPrice(Number(removeFormatNumber(this.glPanelForm.localAmount))),
          gstStatus: this.glPanelForm.gstStatus,
          gstRate: this.glPanelForm.gstRate,
          gstAmount: formatPrice(Number(removeFormatNumber(this.glPanelForm.gstAmount))),
          branch: this.glPanelForm.branch,
          accountNoSuffix: this.glPanelForm.accountNoSuffix,
          fund: this.glPanelForm.fund,
          mixGlAccountNo: this.glPanelForm.mixGlAccountNo,
          glAnCode1: this.glPanelForm.glAnCode1,
          glAnCode2: this.glPanelForm.glAnCode2,
          glAnCode3: this.glPanelForm.glAnCode3,
          glAnCode4: this.glPanelForm.glAnCode4,
          glAnCode5: this.glPanelForm.glAnCode5,
          glAnCode6: this.glPanelForm.glAnCode6,
          glAnCode7: this.glPanelForm.glAnCode7,
          glAnCode8: this.glPanelForm.glAnCode8,
          glAnCode9: this.glPanelForm.glAnCode9,
          glAnCode10: this.glPanelForm.glAnCode10
        }
        this.itemsGL.push(glDetailList)
        this.glItemNo = this.glItemNo + 1
      }

      this.glPanel = []
      var thisPage = this
      Object.keys(this.glPanelForm).forEach(function (key, index) {
        thisPage.glPanelForm[key] = ''
      })
      this.calculateRemainAmount()
    },
    doRemove(data) {
      this.loading = true
      this.glItemNo = 6
      for (var i = 0; i < this.itemsGL.length; i++) {
        if (this.itemsGL[i].glInterface !== '5001' && this.itemsGL[i].glInterface !== '6002' && this.itemsGL[i].glInterface !== '6003') {
          if (
            this.itemsGL[i].glInterface === data.glInterface &&
            this.itemsGL[i].itemNo === data.itemNo &&
            this.itemsGL[i].glAccountNo === data.glAccountNo &&
            this.itemsGL[i].branch === data.branch &&
            this.itemsGL[i].fund === data.fund &&
            this.itemsGL[i].accountNoSuffix === data.accountNoSuffix
          ) {
            this.$delete(this.itemsGL, i)
            this.glListingForm.remainAmountToPost = '0.00'
          }
        }
        if (data.glInterface === '5001' || data.glInterface === '6002' || data.glInterface === '6003') {
          this.promptCannotRemoveAccount = true
        }
      }
      this.tempGLList = this.itemsGL
      this.itemsGL = []
      var itemNo = this.glItemNo
      for (var ii = 0; ii < this.tempGLList.length; ii++) {
        const glDetailList = {
          glInterface: this.tempGLList[ii].glInterface,
          itemNo: this.tempGLList[ii].glInterface === '6001' ? itemNo : this.tempGLList[ii].itemNo,
          glAccountNo: this.tempGLList[ii].glAccountNo,
          description: this.tempGLList[ii].description,
          curr: this.tempGLList[ii].curr,
          amount: this.tempGLList[ii].amount,
          localAmount: this.tempGLList[ii].localAmount,
          gstStatus: this.tempGLList[ii].gstStatus,
          gstRate: this.tempGLList[ii].gstRate,
          gstAmount: this.tempGLList[ii].gstAmount,
          branch: this.tempGLList[ii].branch,
          accountNoSuffix: this.tempGLList[ii].accountNoSuffix,
          fund: this.tempGLList[ii].fund,
          mixGlAccountNo: this.tempGLList[ii].mixGlAccountNo,
          glAnCode1: this.tempGLList[ii].glAnCode1,
          glAnCode2: this.tempGLList[ii].glAnCode2,
          glAnCode3: this.tempGLList[ii].glAnCode3,
          glAnCode4: this.tempGLList[ii].glAnCode4,
          glAnCode5: this.tempGLList[ii].glAnCode5,
          glAnCode6: this.tempGLList[ii].glAnCode6,
          glAnCode7: this.tempGLList[ii].glAnCode7,
          glAnCode8: this.tempGLList[ii].glAnCode8,
          glAnCode9: this.tempGLList[ii].glAnCode9,
          glAnCode10: this.tempGLList[ii].glAnCode10
        }
        if (this.tempGLList[ii].glInterface === '6001') {
          this.glItemNo = this.glItemNo + 1
          itemNo = this.glItemNo
        }
        this.itemsGL.push(glDetailList)
      }
      this.calculateRemainAmount()
    },
    closeDialog() {
      this.promptCannotRemoveAccount = false
    },
    doEdit(data) {
      this.glPanel = [0]
      if (data.deleteData === false) {
        this.isDisabled = true
      } else {
        this.isDisabled = false
      }
      this.glPanelForm.glInterface = data.glInterface
      this.glPanelForm.itemNo = data.itemNo
      this.glPanelForm.glAccountNo = data.glAccountNo
      this.glPanelForm.mixGlAccountNo = data.mixGlAccountNo
      this.glPanelForm.description = data.description
      this.glPanelForm.curr = data.curr
      this.glPanelForm.amount = data.amount
      this.glPanelForm.localAmount = data.localAmount
      this.glPanelForm.gstStatus = data.gstStatus
      this.glPanelForm.gstRate = data.gstRate
      this.glPanelForm.gstAmount = data.gstAmount
      this.glPanelForm.branch = data.branch
      this.glPanelForm.accountNoSuffix = data.accountNoSuffix
      this.glPanelForm.fund = data.fund
      this.glPanelForm.glAnCode1 = data.glAnCode1
      this.glPanelForm.glAnCode2 = data.glAnCode2
      this.glPanelForm.glAnCode3 = data.glAnCode3
      this.glPanelForm.glAnCode4 = data.glAnCode4
      this.glPanelForm.glAnCode5 = data.glAnCode5
      this.glPanelForm.glAnCode6 = data.glAnCode6
      this.glPanelForm.glAnCode7 = data.glAnCode7
      this.glPanelForm.glAnCode8 = data.glAnCode8
      this.glPanelForm.glAnCode9 = data.glAnCode9
      this.glPanelForm.glAnCode10 = data.glAnCode10
    },
    GLAnCodeHelpList(field) {
      this.glAnCodeField = field
      this.showGLAnCodeHelpList = true
    },
    changeGstRate(gstStatus) {
      this.getCommonData('gstrate', gstStatus, formatDisplayDateTime2(this.creditNoteData.tranDate))
    },
    assignGSTRate(data) {
      this.glPanelForm.gstRate = formatPrice(data)
      this.calculateAmount()
    },
    assignGlAnCodeInfo(data) {
      if (this.glAnCodeField === 'glAnCode1') {
        this.glPanelForm.glAnCode1 = data.glanCode
      } else if (this.glAnCodeField === 'glAnCode2') {
        this.glPanelForm.glAnCode2 = data.glanCode
      } else if (this.glAnCodeField === 'glAnCode3') {
        this.glPanelForm.glAnCode3 = data.glanCode
      } else if (this.glAnCodeField === 'glAnCode4') {
        this.glPanelForm.glAnCode4 = data.glanCode
      } else if (this.glAnCodeField === 'glAnCode5') {
        this.glPanelForm.glAnCode5 = data.glanCode
      } else if (this.glAnCodeField === 'glAnCode6') {
        this.glPanelForm.glAnCode6 = data.glanCode
      } else if (this.glAnCodeField === 'glAnCode7') {
        this.glPanelForm.glAnCode7 = data.glanCode
      } else if (this.glAnCodeField === 'glAnCode8') {
        this.glPanelForm.glAnCode8 = data.glanCode
      } else if (this.glAnCodeField === 'glAnCode9') {
        this.glPanelForm.glAnCode9 = data.glanCode
      } else if (this.glAnCodeField === 'glAnCode10') {
        this.glPanelForm.glAnCode10 = data.glanCode
      }
      this.showGLAnCodeHelpList = false
    },
    calculateAmount() {
      if (this.glPanelForm.curr !== this.glListingForm.bankTotalLocalCurr) {
        this.glPanelForm.localAmount = formatPrice(
          Number(removeFormatNumber(this.glPanelForm.amount)) *
            (Number(removeFormatNumber(this.glListingForm.netLocalAmount)) / Number(removeFormatNumber(this.glListingForm.netAmount)))
        )
      } else {
        this.glPanelForm.localAmount = formatPrice(Number(removeFormatNumber(this.glPanelForm.amount)))
      }
      this.glPanelForm.gstAmount = formatPrice((Number(removeFormatNumber(this.glPanelForm.amount)) * Number(this.glPanelForm.gstRate)) / 100)
    },
    assignGlAcctInfo(data) {
      if (this.glPanelForm.glInterface !== '' && this.glPanelForm.glAccountNo !== '' && this.glPanelForm.mixGlAccountNo !== '') {
        const existGLDetailList = {
          glInterface: this.glPanelForm.glInterface,
          itemNo: this.glPanelForm.itemNo,
          glAccountNo: this.glPanelForm.glAccountNo,
          branch: this.glPanelForm.branch,
          accountNoSuffix: this.glPanelForm.accountNoSuffix,
          fund: this.glPanelForm.fund
        }
        this.itemsDeleteGL.push(existGLDetailList)
      }
      this.glPanelForm.glInterface = '6001'
      this.glPanelForm.itemNo = this.glItemNo
      this.glPanelForm.glAccountNo = data.glacctNo
      this.glPanelForm.description = data.description
      this.glPanelForm.curr = this.creditNoteData.currency
      this.glPanelForm.amount = '0.00'
      this.glPanelForm.localAmount = '0.00'
      this.glPanelForm.gstStatus = ''
      this.glPanelForm.gstRate = '0.00'
      this.glPanelForm.gstAmount = '0.00'
      this.glPanelForm.branch = data.branch
      this.glPanelForm.accountNoSuffix = data.suffix
      this.glPanelForm.fund = data.fund
      this.glPanelForm.mixGlAccountNo = data.branch + ' ' + data.glacctNo + ' ' + data.fund + ' ' + data.suffix
      this.glPanelForm.glAnCode1 = ''
      this.glPanelForm.glAnCode2 = ''
      this.glPanelForm.glAnCode3 = ''
      this.glPanelForm.glAnCode4 = ''
      this.glPanelForm.glAnCode5 = ''
      this.glPanelForm.glAnCode6 = ''
      this.glPanelForm.glAnCode7 = ''
      this.glPanelForm.glAnCode8 = ''
      this.glPanelForm.glAnCode9 = ''
      this.glPanelForm.glAnCode10 = ''
      this.isDisabled = false
    }
  },
  computed: {
    glColumns() {
      let result = []
      for (const selectedGLColumns of this.selectedGLColumns) {
        let findCol = this.GLColummn.find((a) => selectedGLColumns === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    creditNoteData() {
      return this.$store.state.creditNote.creditNoteData
    },
    tDateRange() {
      return this.trandaterange
    },
    displayErrorDialog() {
      return this.messages
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [routeMixin, MessageMixin, TableConst.default, crGLTransactionAjaxMixin, creditNoteViewMixin, accountsFilters, commonAjaxMixin],
  components: {
    GlAcctNoHelpList3,
    GlAnCodeHelpList
  }
}
</script>

<style lang="scss">
@import '../../../../assets/scss/accounting.scss';
</style>
